import { getModularClient } from '@leedpulse-monorepo/firebase-client';
import { FirestoreCollections } from '@leedpulse-monorepo/firebase-metadata';

const { app: firebaseApp, firestore, auth } = getModularClient('frontendleedflow');

export { firebaseApp, firestore, auth, FirestoreCollections };
